import { useState } from 'react';

// Three short lists captured at Final Check: didGood / didBad / lookouts.
// Each is an array of one-liners (chip-style). New entries via the input row;
// click a chip to remove it. Optional — empty arrays are fine.

const SECTIONS = [
  { key: 'didGood', label: 'What worked', placeholder: 'e.g. tight overview, strong takeaways…' },
  { key: 'didBad', label: 'What didn\'t', placeholder: 'e.g. AI rewrites flat, two compliance flags…' },
  { key: 'lookouts', label: 'Lookouts', placeholder: 'e.g. watch for FAA NPRM Friday…' },
];

function ChipRow({ items, onAdd, onRemove, placeholder }) {
  const [draft, setDraft] = useState('');

  function commit() {
    const v = draft.trim();
    if (!v) return;
    onAdd(v);
    setDraft('');
  }

  return (
    <div>
      <div className="flex flex-wrap gap-1.5 mb-2">
        {items.length === 0 && (
          <span className="text-[11px] text-hxd-muted italic">No entries yet.</span>
        )}
        {items.map((item, i) => (
          <button
            key={`${item}-${i}`}
            type="button"
            onClick={() => onRemove(i)}
            className="text-[12px] px-2 py-1 rounded-[3px] border border-hxd-border bg-white hover:border-hxd-err hover:text-hxd-err"
            title="Click to remove"
          >
            {item}
            <span className="ml-1 text-hxd-muted text-[10px]">✕</span>
          </button>
        ))}
      </div>
      <div className="flex gap-2">
        <input
          className="hxd-input flex-1"
          placeholder={placeholder}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              commit();
            }
          }}
        />
        <button
          type="button"
          onClick={commit}
          disabled={!draft.trim()}
          className="hxd-btn hxd-btn-ghost hxd-btn-sm"
        >
          Add
        </button>
      </div>
    </div>
  );
}

export default function ReflectionInline({ reflection, onChange }) {
  const safe = {
    didGood: Array.isArray(reflection?.didGood) ? reflection.didGood : [],
    didBad: Array.isArray(reflection?.didBad) ? reflection.didBad : [],
    lookouts: Array.isArray(reflection?.lookouts) ? reflection.lookouts : [],
  };

  function patch(key, next) {
    onChange({ ...safe, [key]: next });
  }

  return (
    <div className="space-y-4">
      {SECTIONS.map((s) => (
        <div key={s.key}>
          <div className="font-display text-[10px] font-bold tracking-display-md uppercase text-hxd-muted mb-2">
            {s.label}
          </div>
          <ChipRow
            items={safe[s.key]}
            placeholder={s.placeholder}
            onAdd={(v) => patch(s.key, [...safe[s.key], v])}
            onRemove={(i) => patch(s.key, safe[s.key].filter((_, j) => j !== i))}
          />
        </div>
      ))}
    </div>
  );
}
